import styled from 'styled-components';

interface ContainerProps {
  hasError: boolean;
}

export const Container = styled.div<ContainerProps>`
  .jodit-wysiwyg {
    color: #000 !important;
  }
`;
